module.exports = __webpack_public_path__ + "static/media/NAPAKnowHow.523d06cb.JPG";